export interface Person_Kari_Interface {
  id:number,
  person_id:number,
  date_starrt:String,
  date_end:String,
  companyName:String,
  type:String,
  semat:String,
  leave:String,
  tel:String,
  address:String
}

export function Empty_Person_Kari_Interface(){
  return{
    id:0,
    person_id:0,
    date_starrt:'',
    date_end:'',
    companyName:'',
    type:'',
    semat:'',
    leave:'',
    tel:'',
    address:''
  }
}
